import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'

import { Icon } from '@/components/icon'
import { Button } from '@/components/ui'
import { AtendimentoDropdownMenu } from '@/features/atendimento/components/atendimento-dropdown'
import { useAtendimento } from '@/features/atendimento/hooks'

export const AtendimentoTrigger = () => {
  const { t } = useTranslation('atendimento')
  const { atendimento } = useAtendimento()
  if (atendimento?.id) return <AtendimentoDropdownMenu cliente={atendimento.cliente} />

  return (
    <Button variant="secondary" asChild className="font-nunito shadow-cz bg-white font-semibold text-neutral-700">
      <Link to="/atendimento/iniciar">
        <Icon name="square-play" className="text-neutral-400" size={20} />
        {t('iniciar_atendimento')}
      </Link>
    </Button>
  )
}
